function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M13.7,6.1c-1.6,0-3.2,1.1-3.6,2.8c-0.4,1.6-0.7,3.2-1.1,4.8c-0.6,2.5-1.1,5-1.7,7.4c0,0.1,0,0.3-0.1,0.5 c2.9,0,5.8,0,8.7,0V6.1C15.2,6.1,14.4,6.1,13.7,6.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M24.3,21.4c-0.2-1-0.5-2-0.7-3c-0.2-0.9-0.4-1.9-0.7-2.8c-0.2-1-0.4-1.9-0.7-2.9c-0.1-0.6-0.3-1.1-0.4-1.7 c-0.2-0.8-0.3-1.6-0.6-2.3C20.8,7,19.6,6.2,18,6.1c-0.7,0-1.4,0-2.1,0v15.5c2.8,0,5.6,0,8.4,0C24.3,21.5,24.3,21.4,24.3,21.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M31.8,13.2c0-0.2-0.1-0.3-0.2-0.3c-0.1,0-0.2,0-0.3,0c-2.1,0-4.2,0-6.3,0c-0.3,0-0.6,0-0.9,0 c-0.1,0-0.3,0-0.3,0.1c0,0.2-0.1,0.4,0,0.6c0,0.2,0.2,0.1,0.3,0.1c1.2,0,2.4,0,3.6,0c0,0,0,0,0,0c1.2,0,2.4,0,3.6,0 C31.8,13.7,31.8,13.6,31.8,13.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M8,12.9c0-0.3-0.1-0.4-0.4-0.4c-0.1,0-0.1,0-0.2,0c-2.1,0-4.2,0-6.3,0c-0.3,0-0.6,0-0.9,0 c-0.2,0-0.3,0.1-0.3,0.3c0,0.3,0.1,0.5,0.3,0.5c0.1,0,0.3,0,0.4,0c1.1,0,2.2,0,3.4,0c0,0,0,0,0,0c1.2,0,2.4,0,3.6,0 C8,13.3,8,13.2,8,12.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1.1,8.9C2.4,9.1,3.7,9.3,5,9.5C6.1,9.7,7.2,9.8,8.2,10c0,0,0.1,0,0.1,0c0.2,0,0.3-0.4,0.3-0.6 c0-0.2-0.2-0.3-0.4-0.3C7.8,9.1,7.4,9,6.9,9C5.4,8.7,3.8,8.5,2.3,8.2C1.9,8.2,1.5,8.1,1,8c-0.1,0-0.2,0.1-0.3,0.2 C0.6,8.6,0.7,8.8,1.1,8.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M21.6,5.6c0.5-0.4,1.1-0.8,1.6-1.2c1.4-1.1,2.9-2.2,4.3-3.2c0.1-0.1,0.1-0.1,0.2-0.3c-0.1-0.2-0.3-0.4-0.4-0.5 c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.3-0.7,0.5-1.1,0.8c-1.6,1.2-3.1,2.4-4.7,3.6c-0.2,0.2-0.3,0.3-0.1,0.5C21.3,5.7,21.3,5.8,21.6,5.6z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M23.6,9.5c-0.7,0.1-0.5,0.2-0.4,0.7c0,0.1,0.1,0.1,0.2,0.2c0.2,0,0.4-0.1,0.6-0.1c1.6-0.2,3.1-0.5,4.7-0.7 c0.7-0.1,1.4-0.2,2.1-0.3c0.3-0.1,0.4-0.1,0.3-0.6c0-0.2-0.2-0.3-0.4-0.2c-1.3,0.2-2.6,0.4-3.8,0.6C25.7,9.2,24.7,9.4,23.6,9.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M22.8,7.7C22.8,7.8,22.8,7.8,22.8,7.7c0.1,0.2,0.2,0.2,0.3,0.1C24.7,6.9,26.3,6,28,5c0.5-0.3,1.1-0.6,1.6-0.9 C29.7,4,29.7,4,29.8,3.9c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.2,0-0.4,0.1c-0.1,0-0.1,0.1-0.2,0.1c-2,1.2-4,2.3-6,3.5 C22.5,7.3,22.5,7.3,22.8,7.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M4.5,0.8c1,0.8,2,1.5,3,2.3c0.9,0.7,1.8,1.4,2.7,2c0.3,0.2,0.4,0.2,0.6,0c0.2-0.2,0.2-0.4-0.1-0.6 C10,4,9.4,3.6,8.8,3.1c-1.3-1-2.6-2-3.8-2.9C4.9,0.1,4.8,0.1,4.7,0C4.6,0,4.5,0,4.5,0.1C4.2,0.3,4.1,0.6,4.5,0.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M2.3,3.7C2.7,4,3.1,4.2,3.5,4.4c1.7,1,3.3,1.9,5,2.9c0.1,0.1,0.2,0.1,0.2,0.1C9,7.4,9.1,7.2,9.2,7 C9.2,6.9,9.1,6.8,9,6.7C8,6.1,7.1,5.6,6.1,5C5,4.3,3.8,3.7,2.7,3C2.4,2.9,2.3,2.9,2.1,3.2C2,3.4,2,3.5,2.3,3.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M25.7,21.6h-9.8v5.1h9.8c0.5,0,0.9-0.4,0.9-0.9v-3.4C26.6,22,26.2,21.6,25.7,21.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M6.1,21.6c-0.5,0-0.9,0.4-0.9,0.9v3.4c0,0.5,0.4,0.9,0.9,0.9h9.8v-5.1H6.1z"
}));

var SvgAdvertencia = function SvgAdvertencia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.8 26.7",
    style: {
      enableBackground: "new 0 0 31.8 26.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdvertencia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ADVERTENCIA.c7082392.svg";
export { ForwardRef as ReactComponent };